import { z } from 'zod';

const blockEquipmentSchema = z.object({
  date: z.date({ required_error: 'schemas.common.dateRequired' }),
  time: z.array(z.object({ slot: z.string(), status: z.string() }))
});

export default blockEquipmentSchema;
